import * as Popover from '@radix-ui/react-popover'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

import ArrowIcon from '/icons/arrow.svg'
// import EnIcon from '/icons/locale/en.svg'
import KkIcon from '/icons/locale/kk.svg'
import RuIcon from '/icons/locale/ru.svg'

interface SwitchLocaleProps {
  className?: string;
  isMenu?: boolean;
}

export default function SwitchLocale ({ className, isMenu }: SwitchLocaleProps) {
  const { i18n } = useTranslation()
  const { t: tn } = useTranslation('navigation')
  const { language } = i18n
  const [ isOpen, setIsOpen ] = useState(false)

  const languages = [
    { code: 'ru', name: 'Русский', icon: RuIcon },
    { code: 'kk', name: 'Қазақша', icon: KkIcon },
    // { code: 'en', name: 'English', icon: EnIcon },
  ]

  const handleToggle = () => setIsOpen((prev) => !prev)

  const renderLanguageList = () =>
    languages.map((lang) => (
      <button
        key={lang.code}
        className={cn('reset-button', styles.language, {
          [styles._current]: language == lang.code,
        })}
        type="button"
        onClick={() => {
          i18n.changeLanguage(lang.code)
          if (isMenu) {
            setIsOpen(false)
          }
        }}
      >
        <span className={styles['language__icon']}>
          <img
            src={lang.icon}
            alt={lang.name}
            loading="lazy"
            fetchPriority="low"
          />
        </span>
        {lang.name}
      </button>
    ))

  const renderTrigger = (isMenu?: boolean) => (
    <button
      className={cn(styles.trigger, 'reset-button', className, {
        [styles.triggerInline]: isMenu,
        [styles.triggerInlineOpen]: isOpen,
      })}
    >
      {isMenu && (
        <span className={styles.triggerLabel}>{tn('language.label')}</span>
      )}
      {language}
      <img
        className={styles['trigger__icon']}
        src={ArrowIcon}
        alt=""
        loading="lazy"
        fetchPriority="low"
      />
    </button>
  )

  if (isMenu) {
    return (
      <div className={styles.triggerStatic}>
        <div className={styles.triggerBtn} onClick={handleToggle}>
          {renderTrigger(isMenu)}
        </div>
        <div
          className={cn(styles.triggerBox, {
            [styles.triggerBoxVisible]: isOpen,
          })}
        >
          <span className={styles.triggerBoxTitle}>
            {tn('language.select')}
          </span>
          {renderLanguageList()}
        </div>
      </div>
    )
  }

  return (
    <Popover.Root>
      <Popover.Trigger asChild>{renderTrigger()}</Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className={styles.content} sideOffset={15}>
          {renderLanguageList()}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}
